// @ts-nocheck
import React from "react";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { PostApi } from "../../../ApiClient/PostApi";
import { error_toaster, success_toaster } from "../../toaster/Toaster";
import ListItem, { MiniItem } from "./leftbarElements/ListItem";

export default function Leftbar() {
  const location = useLocation().pathname;

  const navigate = useNavigate();
  const [loading, SetLoading] = useState(false);
  const [search, setSearch] = useState("");
  const logoutAdmin = async () => {
    SetLoading(true);
    const res = await PostApi("logout", {
      accessToken: localStorage.getItem("accessToken"),
    });
    if (res.data.status === "1") {
      success_toaster(res.data.message);
      SetLoading(false);
      localStorage.removeItem("loginstatus");
      localStorage.removeItem("accessToken");
      navigate("/login");
    } else {
      error_toaster(res.data.message);
      SetLoading(false);
    }
  };

  const menuItems = [
    { path: "/", text: "Dashboard", icon: "1", activePaths: ["/"] },
    {
      path: "/incoming_orders",
      text: "Incoming Orders",
      icon: "2",
      activePaths: ["/incoming_orders", "/arrived_orders", "/delayed_orders", "/cancelled_orders"],
    },
    {
      path: "/incomplete_orders",
      text: "Incomplete",
      icon: "3",
      activePaths: ["/incomplete_orders", "/incomplete_orders/details"],
    },
    {
      path: "/inprocess_orders",
      text: "In Process",
      icon: "4",
      activePaths: ["/inprocess_orders", "/pending_payment", "/ready_to_ship"],
    },
    {
      path: "/outgoing_orders",
      text: "Outgoing Orders",
      icon: "5",
      activePaths: ["/outgoing_orders", "/arrived_at_local_hub", "/delivered"],
    },
    { path: "/completed_orders", text: "Completed Orders", icon: "2", activePaths: ["/completed_orders"] },
    { path: "/users", text: "User Management", icon: "6", activePaths: ["/users", "/users/user_details"] },
    { path: "/unit_management", text: "Unit Management", icon: "7", activePaths: ["/unit_management"] },
    { path: "/add_prices", text: "Add Price", icon: "7", activePaths: ["/add_prices"] },
    { path: "/my_wallet", text: "My Wallet", icon: "8", activePaths: ["/my_wallet"] },
    { path: "/transaction_history", text: "Transaction History", icon: "9", activePaths: ["/transaction_history"] },
    { path: "/all_otps", text: "Otps", icon: "11", activePaths: ["/all_otps"] },
    { path: "/add_employee", text: "Add Employee", icon: "2", activePaths: ["/add_employee"] },
    { path: "/all_employees", text: "All Employees", icon: "3", activePaths: ["/all_employees"] },
    { path: "/all_roles", text: "All Roles", icon: "4", activePaths: ["/all_roles"] },
    { path: "/permissions", text: "Permissions", icon: "5", activePaths: ["/permissions"] },
    { path: "/privacy_policy", text: "Privacy & Policy", icon: "6", activePaths: ["/privacy_policy"] },
    { path: "/companies", text: "Companies", icon: "7", activePaths: ["/companies"] },
    { path: "/company_rates", text: "Company Rates", icon: "7", activePaths: ["/company_rates"] },
    { path: "/all_reviews", text: "Notes", icon: "8", activePaths: ["/all_reviews"] },
    { path: "/messages", text: "All Messages", icon: "9", activePaths: ["/messages"] },
    { path: "/social_links", text: "Social Links", icon: "10", activePaths: ["/social_links"] },
    { path: "/profile", text: "Admin Profile", icon: "6", activePaths: ["/profile"] },
  ];

  const filteredMenu = menuItems.filter((item) =>
    item.text.toLowerCase().includes(search.trim().toLowerCase())
  );

  return (
    <div className="bg-themeBlue xl:w-[280px] w-60 fixed h-full py-7 pl-8 pr-5 flex flex-col gap-y-12">
      <Link to={"/"}>
        <img src="/images/logo.webp" alt="logo" className="w-36" />
      </Link>
      <div className="h-full">
        <div className="mb-4">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search tab..."
            className="w-full rounded-md bg-white/10 text-white placeholder:text-white/70 border border-white/20 px-3 py-2 text-sm focus:outline-none"
          />
        </div>
        <ul className="flex flex-col gap-y-7 h-4/5 overflow-auto sidebar">
          {filteredMenu.map((item) => (
            <ListItem
              key={item.path}
              path={item.path}
              text={item.text}
              icon={item.icon}
              opacity={item.activePaths.includes(location) ? "opacity-100" : "opacity-60"}
            />
          ))}
        </ul>
        <div className="flex items-center gap-x-8 absolute bottom-7">
          <MiniItem path="/" icon="10" />
          <MiniItem path="/warehouse_address" icon="11" />
          {loading ? (
            <p>Loading...</p>
          ) : (
            <button onClick={logoutAdmin} style={{ color: "white" }}>
              <MiniItem icon="12" />
            </button>
          )}

          {/* <MiniItem  icon="12" /> */}
        </div>
      </div>
    </div>
  );
}
